<template>

    <div class="calculadora" v-if="showCalc && showCalcProp">
        <div class="calculadora-header">
            <h4>Cálculo de Data</h4>
        </div>       
              <v-form ref="form">
        <v-container class="ma-0 pa-0">  <!-- Reduzir padding vertical -->       
            <v-menu
                ref="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
            
                <template v-slot:activator="{ on, attrs }">
                <datePicker                         
                        v-model="dateFormatado"                       
                        label="Data inicial" 
                        v-mask="maskData"                        
                        v-bind="attrs"
                        @blur="date = parseDate(dateFormatado)"
                        v-on="on"   
                        ref="DataCalc"                                              
                        :show-current="false"
                        dense
                        />                    
                </template>                
            </v-menu>

            <div >
                
                    <v-text-field
                        v-model="qtdDias"
                        label="Quantidade de dias"
                        required
                        type="number"
                        maxlength="3"
                        min="0"
                        @blur="validaCampos()"
                        dense
                        hide-details
                        class="my-1 ma-0 pa-0"
                    ></v-text-field>
                

                <v-layout
                    cols="12"
                    md="4"
                >
                    <v-text-field
                        v-model="dataFutura"
                        readonly
                        aria-disabled="true"
                        label="Próxima"
                        dense
                        hide-details
                        class="my-1 ma-0 pa-0"                      
                    ></v-text-field>
                </v-layout>

                <v-btn
                    text
                    small 
                    color="primary"                    
                    :disabled="clickable"
                    @click="calcular()"
                    class="pa-0"
                    style="height: 24px; width: 272.5px; min-width: 80px; margin-top: 5px; margin-left: 11px;"
                >
                    Calcular
                </v-btn> 
                
                <v-btn
                    text
                    small
                    color="error"
                    @click="btnFechar()"
                    class="pa-0"
                    style="height: 24px; width: 272.5px; min-width: 80px;"
                >
                    Fechar
                </v-btn>
            </div>
            
        </v-container>
              </v-form>
    </div>
</template>

<style>
.calculadora {
  
  height: 380px;
  width: 300px;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  display: flex; 
  flex-direction: column; 
  align-items: center;
}

.calculadora h4 {
  text-align: left; /* Alinha o texto à esquerda */
  font-size: 17px;
  font-weight: bold;
  padding: 10px 0 10px 15px; /* Adiciona padding para afastar das bordas */
  margin: 0; /* Remove margens negativas */
  border-bottom: 1px solid #e0e0e0; /* Adiciona borda inferior */
  width: 100%; /* Garante que o título ocupe toda a largura */
}


.calculadora .v-input__slot {
  background: #fff;
  width: 275px;
  height: 45px;
  margin-left: 10px;
  margin-bottom: 4px;
  margin-top: 2px;
}

.calculadora .v-text-field__slot {
  background: #fff;
}

.calculadora .error {
    margin: 5px 10px 10px 10px !important;
    height: 24px;
    width: 25px; 
}

.calculadora .v-messages {
    display: none !important;
}

.calculadora .v-text-field {
    padding: 15 !important;
}
</style>

<script>
import moment from "moment";
import util from "../plugins/util";
export default {
    props: {
       showCalcProp: Boolean,
       LimpaCampos: Object
    },
 mixins: [util],  
    data: function () {
        return {
            date: '',
            dateFormatado: '',
            qtdDias: null,
            clickable: true,
            dataFutura: '',
            showCalc: true,
            
        }
    },

    methods: {
        limpaForm () {            
             for (field in this.fields) this.fields[field] = ""            
         },
        formatDate:function  (date) {     

        if (!date) return null

        var arr= date.split('-'),
                year = arr[0],
                month =  arr[1],
                day=  arr[2];
        return `${day}/${month}/${year}`
        },
        parseDate:function  (date) {
            if (!date) return null

            var arr = date.split('/'),
                        day = arr[0],
                        month =  arr[1],
                        year =  arr[2];
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        calcular() {
            var setQtdDias = this.qtdDias;
            var arr = this.dateFormatado.split('-');

            var dataFutura = moment(arr, "YYYY/MM/DD").add(setQtdDias, 'days');

            var setDia = dataFutura.format('DD');
            var setMesa = dataFutura.format('MM');
            var setAno = dataFutura.format('YYYY');

            var retDataFutura = setDia + '/' + setMesa + '/' + setAno;
            this.dataFutura = retDataFutura;          
            
        },
        validaCampos() {
            var setQtdDias = this.qtdDias;
            var calend = this.dateFormatado;      

            if(setQtdDias != null && calend != '') {
                this.clickable = false;
            } 

            if(setQtdDias == '') {
                this.clickable = true;
            }           
        },
        btnFechar() {
            this.$refs.form.reset();
            this.showCalc = false
          
        }
        
    },
  
    computed: {
        computeddateFormatado () {
            return this.formatDate(this.date)
        },
    },

    watch: {
        date (val) {
            this.dateFormatado = this.formatDate(this.date)
        },   

        LimpaCampos: function(newValue,OldValue) { // watch it
            if(this.showCalc){
                this.$refs.form.reset();
            }
         this.showCalc = true;
          
        }           

    },

}
</script>